import { krdetailConstants } from "../constants/krdetails.constants";
import { removeReactLoader } from "../utils/common.js";
import GoalServices from "../services/goal.services";
import { commentActions } from "./comment.actions";
import KrDetailsReducer from '../reducers/krDetails.reducers'
import qs from "qs";
import { WoboFileUploadService } from './../services/fileupload.service';
import { didStoreDataChange } from "../utils/didStoreDataChange";
export const krDetailData = (item) => ({
  item,
});

let services = new GoalServices();

const updateKRReactedEmoji = (data) => (dispatch) =>
  dispatch({
    type: krdetailConstants.UPDATE_KR_REACTED_EMOJI,
    data,
  });

function updatekrHeader(id, urlParams = {}, checkDelta = false) {
  return (dispatch, getState) => {
    let oldId = "";
    if (typeof urlParams.oldId !== "undefined") {
      oldId = urlParams.oldId;
      delete urlParams.oldId;
    }
    let params = Object.assign(
      { id: id, previousUrl: false, json: true },
      urlParams
    );
    // getting data source
    dispatch(getDataSource(id, checkDelta));
    services
      .getKrHeaders(params)
      .then((response) => {
        removeReactLoader(getState());
        if (response.data) {
          const data = response.data;
          const action = success(data, oldId);
          const shouldUpdateKrHeaders = !checkDelta || didStoreDataChange(
            getState()?.KrReducers,
            action,
            KrDetailsReducer,
            (diffString) => services.logDataDog(`KR-Recalculate-Delta KR:${id}, DIFF: ${diffString}`)
          );
          
          if(!shouldUpdateKrHeaders) return;

          dispatch(action);
          const { metric, goal } = data.data;
          if (typeof metric !== "undefined") {
            let goalId = metric.goal_id || metric.cascade_goal_id;
            
            dispatch(fetchKrAttachments(id, checkDelta));
            if (!goalId && typeof goal !== "undefined") {
              goalId = goal.id;
            }
            if (goalId) {
              dispatch(fetchGraphData(goalId, id, checkDelta));
              dispatch(commentActions.fetchCommentList(goalId, id));
              dispatch(smilarKeyResults(goalId, id, metric.name, checkDelta));
          }
          if (oldId) {
            let query = Object.assign({ id }, urlParams);
            let url =
              wbConfig.baseUrl +
              "/goal/krDetails?" +
              qs.stringify(query, { arrayFormat: "brackets" });
            windowHistoryPushState(url);
          }
        }
      }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  function success(data, oldId = "") {
    return { type: krdetailConstants.GET_KRDETAILS_SUCCSESS, data, oldId };
  }
}
function getDataSource(metricId, checkDelta = false) {
  return (dispatch, getState) => {
    services
      .getDataSource({ metricId })
      .then((response) => {
        if (response.data) {
          const action = success(response.data.data);
          const shouldUpdateDataSource = !checkDelta || didStoreDataChange(
            getState()?.KrReducers,
            action,
            KrDetailsReducer,
            (diffString) => services.logDataDog(`KR-Recalculate-Delta KR:${metricId}, DIFF: ${diffString}`)
        )
          
          if(!shouldUpdateDataSource) return;
    
          dispatch(action);
        }
      })
      .catch((err) => {
        dispatch(fail());
      });
  };
  function success(data) {
    return { type: krdetailConstants.DATA_SOURCE_SUCCESS, data };
  }
  function fail() {
    return { type: krdetailConstants.DATA_SOURCE_FAIL };
  }
}

function updateMetricAttributes(data = null) {
  return {
    type: krdetailConstants.UPDATE_METRIC_ATTRIBUTES,
    data,
  };
}

function fetchGraphData(goalId, metricId, checkDelta = false) {
  return (dispatch, getState) => {
    services
      .fetchGraphData({ goalId: goalId, metricId: metricId })
      .then((response) => {
        if (response.data) {
          const action = graphDataReceived(response.data);
          const shouldUpdateKrHeaders = !checkDelta || didStoreDataChange(
            getState()?.KrReducers,
            action,
            KrDetailsReducer,
            (diffString) => services.logDataDog(`KR-Recalculate-Delta KR:${id}, DIFF: ${diffString}`)
          );
          
          if(!shouldUpdateKrHeaders) return;
          dispatch(action);
        }
      })
      .catch((err) => {
        dispatch(graphDataReceivedFailed());
      });
    function graphDataReceived(data) {
      return { type: krdetailConstants.GET_GRAPH_DATA_SUCCESS, data };
    }
    function graphDataReceivedFailed() {
      return { type: krdetailConstants.GET_GRAPH_DATA_FAIL };
    }
  };
}

function updateGraphData(surveyUser) {
  return { type: krdetailConstants.GET_GRAPH_DATA_UPD, surveyUser };
}

function editDescription(params) {
  return (dispatch) => {
    services
      .editDescription(params)
      .then((response) => {
        if (response.data) {
          dispatch(success(response.data.description));
        }
      })
      .catch((err) => {
        dispatch(failedit(err));
      });
    function success(data) {
      removeReactLoader();
      return { type: krdetailConstants.SAVE_KR_NOTE, data };
    }
    function failedit(e) {
      removeReactLoader();
      console.log("Error ->", e);
    }
  };
}

function fetchKrAttachments(metricId, checkDelta = false) {
  return (dispatch, getState) => {
    let params = { metricId: metricId };
    services
      .fetchKrAttachments(params)
      .then((response) => {
        if (response.data) {
          const action = success(response.data);
          const shouldUpdateKrHeaders = !checkDelta || didStoreDataChange(
            getState()?.KrReducers,
            action,
            KrDetailsReducer,
            (diffString) => services.logDataDog(`KR-Recalculate-Delta KR:${id}, DIFF: ${diffString}`)
          );
          
          if(!shouldUpdateKrHeaders) return;

          removeLoaderWidget();
          dispatch(action);
        }
      })
      .catch((error) => {
        dispatch(failure());
      });

    function success(data) {
      return { type: krdetailConstants.GET_KR_ATTACHMENT_SUCCESS, data };
    }
    function failure(error) {
      console.log("attachmentList failure", error);
    }
  };
}

function deleteKrAttachments(Id, goalId, signature) {
  return (dispatch) => {
    let attachId = Id;
    let params = { attachId: attachId, goalId: goalId };
    services
      .deleteKrAttachment(params)
      .then((response) => {
        if (response.data) {
          console.log("deleted successfully");
          if (response.data.error) {
            dispatch(failure(response.data.error));
          }
          dispatch(success(attachId));
          if (signature) {
            WoboFileUploadService.delete(signature)
          }
        }
      })
      .catch((error) => {
        console.log("delete error");
      });

    function success(attachId) {
      removeLoaderWidget();
      return { type: krdetailConstants.KR_ATTACHMENT_DELETE_SUCCESS, attachId };
    }
    function failure(error) {
      console.log(error);
    }
  };
}

function saveKrLinkAttachments(data) {
  return (dispatch) => {
    services
      .saveKrLinkAttachments(data)
      .then((response) => {
        removeLoaderWidget();
        if (response.data) {
          if (response.data.error) {
            dispatch(failure(error));
          } else {
            dispatch(success(response.data.data));
          }
        }
      })
      .catch((error) => {
        dispatch(failure(error));
      });

    function success(data) {
      return { type: krdetailConstants.SAVE_KR_ATTACHMENTS_SUCCSESS, data };
    }
    function failure(error) {
      console.log("saveAttachmentLinkError", error);
    }
  };
}

function getviewCascadeTree(data) {
  return (dispatch) => {
    services
      .getviewCascadeTree(data)
      .then((response) => {
        if (response.data) {
          if (response.data.error) {
            dispatch(failure(error));
          } else {
            dispatch(success(response.data));
          }
        }
      })
      .catch((error) => {
        //dispatch(failure(error));
        console.log("error");
      });

    function success(data) {
      return { type: krdetailConstants.GET_CASCADE_TREE_SUCCESS, data };
    }
    function failure(error) {
      console.log("getviewCascadeTree", error);
    }
  };
}

function getAllMetricsByGoal(goalId) {
  return (dispatch) => {
    services
      .getAllMetricsByGoal(goalId)
      .then((response) => {
        if (response.data.goalMetrics) {
          dispatch(success(response.data.goalMetrics, goalId));
        }
      })
      .catch((err) => {
        dispatch(fail());
      });
  };
  function success(data, goalId) {
    return { type: krdetailConstants.GET_METRIC_BY_GOAL, data, goalId };
  }
  function fail() {
    return { type: krdetailConstants.DATA_SOURCE_FAIL };
  }
}

function getAlignTree(goalId, metricId) {
  return (dispatch) => {
    let params = {};
    params.goalId = goalId;
    params.metricId = metricId;
    services
      .getKrAlignTreeData(params)
      .then((response) => {
        if (response.data) {
          dispatch(success(response.data));
        }
      })
      .catch((err) => {
        //dispatch(fail());
      });
  };
  function success(data, goalId) {
    return { type: krdetailConstants.GET_ALIGN_TREE_DATA, data };
  }
}

const updatekrHeaderConfidence = (data) => (dispatch) =>
  dispatch({
    type: krdetailConstants.UPDATE_KR_HEADER_CONFIDENCE,
    data,
  });

function smilarKeyResults(goalId, metricId, text, checkDelta = false) {
  return (dispatch, getState) => {
    services
      .getClusterData({ metricId, goalId, text })
      .then((response) => {
        if (response.data) {
          const action = success(response.data.data);
          const shouldUpdateKrHeaders = !checkDelta || didStoreDataChange(
            getState()?.KrReducers,
            action,
            KrDetailsReducer,
            (diffString) => services.logDataDog(`KR-Recalculate-Delta KR:${id}, DIFF: ${diffString}`)
          );
          
          if(!shouldUpdateKrHeaders) return;
          dispatch(action);
        }
      })
      .catch((err) => {
      });

    function success(data) {
      if (data.metrics[metricId].cKR && data.metrics[metricId].cKR.length > 0) {
        return { type: krdetailConstants.UPDATE_CLUSTER_SIMILAR_DATA, data };
      }      
    }
  };
}



const copyKrDataUpdate = (data) => (dispatch) => {
  dispatch({
    type: krdetailConstants.COPY_KR_DATA_UPDATE,
    data,
  });
  dispatch(fetchGraphData(data.goal.id, data.metric.id));
}

const updateKrAttachment = (signature, delayMs) => {
  return (dispatch) => {
    var clearTimer = setInterval(async () => {
      services
        .getFileStatus({ signature })
        .then((response) => {
          const jsonData = response?.data
          if (jsonData) {
            if (
              jsonData?.resp?.fus_type == 1 &&
              jsonData?.resp?.fus_status == 1 &&
              jsonData?.resp?.path
            ) {
              clearInterval(clearTimer)
              // Update the store data accordingly
              dispatch(success(jsonData))
            }
          }
        })
        .catch((err) => {})
    }, delayMs)
  }
  function success(data) {
    return { type: krdetailConstants.UPDATE_FUS_KR_ATTACHMENT_SUCCESS, data }
  }
  // function fail() {
  //   return { type: krdetailConstants.DATA_SOURCE_FAIL };
  // }
}

export const krdetailActions = {
  updatekrHeader,
  getDataSource,
  fetchGraphData,
  fetchKrAttachments,
  deleteKrAttachments,
  saveKrLinkAttachments,
  getviewCascadeTree,
  editDescription,
  getAllMetricsByGoal,
  updateGraphData,
  getAlignTree,
  updateKRReactedEmoji,
  updateMetricAttributes,
  updatekrHeaderConfidence,
  smilarKeyResults,
  copyKrDataUpdate,
  updateKrAttachment
};